module.exports = __webpack_public_path__ + "img/logo-economy.276d6732.png";